export const copyToClipboard = (text) => {
  return navigator.clipboard.writeText(text)
    .then(() => {
      // console.log('Text copied to clipboard'); // Optional: keep for debugging if needed
      return true; // Indicate success
    })
    .catch(err => {
      console.error('Failed to copy text: ', err);
      alert('Failed to copy. Please try again or copy manually.'); // Provide fallback for critical failure
      return false; // Indicate failure
    });
}; 